import Dashboard from "pages/Dashboard";
import DashboardGoogleSelfService from "pages/DashboardGoogleSelfService";
import Contact from "pages/Contact";
import Loading from "pages/Loading";
import Suggestions from "pages/Suggestions";
import Performance from "pages/Performance";
import PerformanceGoogleSelfService from "pages/PerformanceGoogleSelfService";
import SearchCampaigns from "pages/SearchCampaigns";
import DisplayCampaigns from "pages/DisplayCampaigns";
import Payment from "pages/Payment";
import Wizard from "pages/Wizard";
import Setting from "pages/Setting";
import Monitor from "pages/Monitor";
import NoConnectedAds from "pages/NoConnectedAds";
import DashboardFacebook from "pages/DashboardFacebook";
import PerformanceFacebook from "pages/PerformanceFacebook";
import RmpConversions from "pages/RmpConversions";
import RmpFacebookConversions from "pages/RmpFacebookConversions";

export default [
  {
    path: "/",
    component: Loading,
    noHeader: true,
  },
  {
    path: "/loading",
    component: Loading,
    noHeader: true,
  },
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/dashboard/self-service",
    component: DashboardGoogleSelfService,
  },
  {
    path: "/contact",
    component: Contact,
  },
  {
    path: "/adpro-suggestions",
    component: Suggestions,
  },
  {
    path: "/account-performance",
    component: Performance,
  },
  {
    path: "/rmp-conversions",
    component: RmpConversions,
  },
  {
    path: "/account-performance/self-service",
    component: PerformanceGoogleSelfService,
  },
  {
    path: "/search-campaigns",
    component: SearchCampaigns,
  },
  {
    path: "/display-campaigns",
    component: DisplayCampaigns,
  },
  {
    path: "/payment",
    component: Payment,
  },
  {
    path: "/wizard",
    component: Wizard,
  },
  {
    path: "/setting",
    component: Setting,
  },
  {
    path: "/setting/fb",
    component: Setting,
  },
  {
    path: "/monitor",
    component: Monitor,
    noHeader: true,
  },
  {
    path: "/no-connected-ads",
    component: NoConnectedAds,
  },
  {
    path: "/dashboard/fb",
    component: DashboardFacebook,
  },
  {
    path: "/account-performance/fb",
    component: PerformanceFacebook,
  },
  {
    path: "/rmp-conversions/fb/r-widget",
    component: RmpFacebookConversions,
  },
  {
    path: "/rmp-conversions/fb/r-crm",
    component: RmpFacebookConversions,
  },
  {
    path: "/rmp-conversions/fb/google-sheets",
    component: RmpFacebookConversions,
  },
  {
    path: "/rmp-conversions/r-widget",
    component: RmpConversions,
  },
  {
    path: "/rmp-conversions/r-crm",
    component: RmpConversions,
  },
  {
    path: "/rmp-conversions/google-sheets",
    component: RmpConversions,
  },
];
